module.exports = __webpack_public_path__ + "static/assets/5e517123930f82e5e812dfc23659a233.svg";